import System from "../basic/System";

export function openURL(link, target) {
  if (System.isDesktop())  {
    const { shell } = window.require('electron')
    shell.openExternal(link);
    return undefined;
  } else {
    return window.open(link, target);
  }
}